import GraphQLQuery from './GraphQLQuery';
import GraphQLMutation from './GraphQLMutation';
import Environment, { setupEnvironment } from './Environment';

export {
    GraphQLQuery,
    GraphQLMutation,
    Environment,
    setupEnvironment,
};

export default ({
    GraphQLQuery,
    GraphQLMutation,
});



// WEBPACK FOOTER //
// ./index.js